import { GET_CATEGORIES } from "../actions/ActionTypes";

const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  isLoading: true,
};
const initial = false;
function CategoryReducer(state = initialState, actions) {
  if (actions.type === GET_CATEGORIES) {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (
    actions.type === "LOADING" &&
    actions.payload.action_model === GET_CATEGORIES
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { CategoryReducer };
